import type { StaffAiChatMode } from '@bp-core/src/lib/ai-chat/staff/staff-ai-chat.mapping';

/**
 * El ítem `chat` del menú lateral (049, T111; HU6) es el Asesor IA (nombre e ícono en `data.ts`): se muestra solo si el
 * asesor lo tiene (`GetAvailability.mode = full`). Mientras se consulta, oculto, para no parpadear.
 */
export function usesAdvisorAiChat(mode: StaffAiChatMode): boolean {
  return mode === 'full';
}
